
// // improve this one as well
// // we can use the filtered records view convetion
// import React, { useState, useRef } from "react";

// import { Circles } from "react-loader-spinner";

// const EditableRow = ({
//   handleEditFormSubmit,
//   isLoadingSave,
//   editFormData,
//   handleEditFormChange,
//   handleCancelClick,
//   onStatusChange,
//   names,
//   handleCategoryEdit,
//   optionsPreviledges,
//   contact,foundErrAdd,
// }) => {
//   const [phone, setPhone] = useState(contact.phone);
//   const [username, setUsername] = useState(contact.username);
//   const [email, setEmail] = useState(contact.email);
//   const [farmerID, setFarmerID] = useState(contact.farmerid);

//   const [category, setCategory] = useState(contact.category);
//   const [company, setCompany] = useState(contact.company);

//   //store select values in an array
//   const options = [
//     { value: "", text: "-- select Status --" },
//     { value: "active", text: "active" },
//     { value: "pending", text: "pending" },
//     { value: "disabled", text: "disabled" },
//   ];

//   const companyRef = useRef(contact.company);

//   // const [names, setNames] = useState({
//   //   status: options[0].value,
//   // });

//   return (
//     <tr>
//       <td>{contact.id}</td>
//       <td>
//         <input
//           type="text"
//           placeholder={farmerID}
//           // value={username}
//           // value={contact.username}
//           name="farmerid"
//           onChange={handleEditFormChange}
//         ></input>
//       </td>
//       <td>
//         <input
//           type="text"
//           placeholder={username}
//           // value={username}
//           // value={contact.username}
//           name="username"
//           onChange={handleEditFormChange}
//         ></input>
//       </td>

//       <td>
//         <input
//           type="text"
//           required="required"
//           // placeholder="Edit email"
//           placeholder={email}
//           // value={email}
//           // value={contact.email}
//           name="email"
//           onChange={handleEditFormChange}
//         ></input>
//       </td>

//       <td>
//         <input
//           type="text"
//           placeholder="Edit Password"
//           name="password"
//           onChange={handleEditFormChange}
//         ></input>
//       </td>
//       <td>
//         <input
//           type="text"
//           // pattern="[0-9]*"
//           pattern="[0-9]*"
//           // value={phone}
//           placeholder={phone}
//           onInput={(e) =>
//             setPhone((v) => (e.target.validity.valid ? e.target.value : v))
//           }
//           name="phone"
//           onChange={handleEditFormChange}
//         ></input>
//       </td>
//       <td></td>
//       <td>
//         <input
//           // ref={companyRef}
//           type="text"
//           placeholder={company}
//           // value={company}
//           name="company"
//           onChange={handleEditFormChange}
//         ></input>
//       </td>
//       <td></td>

//       <td>
//         <select
//           className=" f4 bg-white tracked pa2 "
//           value={names.category}
//           onChange={handleCategoryEdit}
//         >
//           {optionsPreviledges.map((option) => (
//             <option key={option.value} value={option.value}>
//               {option.text}
//             </option>
//           ))}
//         </select>
//       </td>
//       <td>
//         <select
//           className=" f4 bg-white tracked pa2 "
//           value={names.status}
//           onChange={onStatusChange}
//         >
//           {options.map((option) => (
//             <option key={option.value} value={option.value}>
//               {option.text}
//             </option>
//           ))}
//         </select>
//       </td>

//       <td>
//        <div className="db">
//         {isLoadingSave ? (
//           <div className="dib ml2 mr2">
//             <Circles type="Oval" color="#000080" height={20} width={40} />
//           </div>
//         ) : null} <div>
//         <button
//           className=" br-pill bw0 bg-orange hover-bg-yellow white pa2"
//           onClick={handleEditFormSubmit}
//         >
//           Save
//         </button>
//         <button
//           type="button"
//           className="ml2 br-pill bw0 bg-orange hover-bg-yellow white pa2"
//           onClick={handleCancelClick}
//         >
//           Cancel
//         </button>
//         </div>
//         <div>
//           <p>
//             {foundErrAdd?"Error!":""}
//           </p>
//         </div>
//         </div>
//       </td>
//     </tr>
//   );
// };

// export default EditableRow;


// // new and improved
// import React from "react";
// import { Circles } from "react-loader-spinner";

// const EditableRow = ({
//   handleEditFormSubmit,
//   isLoadingSave,
//   editFormData,
//   handleEditFormChange,
//   handleCancelClick,
//   optionsPreviledges,
//   contact,
//   foundErrAdd,
// }) => {
//   // FIX: status options now live here (they only ever applied to this
//   // row anyway), and both this select and the category select below are
//   // bound directly to editFormData - the same generic handleEditFormChange
//   // used everywhere else, instead of the separate onStatusChange/
//   // handleCategoryEdit functions that wrote to a disconnected `names`
//   // state shared with the Add form.
//   const statusOptions = [
//     { value: "", text: "-- select Status --" },
//     { value: "active", text: "active" },
//     { value: "pending", text: "pending" },
//     { value: "disabled", text: "disabled" },
//   ];

//   return (
//     <tr>
//       {/* Select column placeholder - a row being edited isn't part of
//           bulk selection */}
//       <td></td>

//       <td>{contact.id}</td>

//       <td>
//         <input
//           type="text"
//           value={editFormData.farmerid || ""}
//           name="farmerid"
//           onChange={handleEditFormChange}
//         />
//       </td>

//       <td>
//         <input
//           type="text"
//           value={editFormData.username || ""}
//           name="username"
//           onChange={handleEditFormChange}
//         />
//       </td>

//       <td>
//         <input
//           type="text"
//           required
//           value={editFormData.email || ""}
//           name="email"
//           onChange={handleEditFormChange}
//         />
//       </td>

//       <td>
//         {/* Left uncontrolled/blank on purpose - avoids ever displaying
//             the existing plaintext password back into an input */}
//         <input
//           type="text"
//           placeholder="Leave blank to keep current password"
//           name="password"
//           onChange={handleEditFormChange}
//         />
//       </td>

//       <td>
//         <input
//           type="text"
//           pattern="[0-9]*"
//           value={editFormData.phone || ""}
//           name="phone"
//           onChange={(e) => {
//             if (e.target.validity.valid) handleEditFormChange(e);
//           }}
//         />
//       </td>

//       <td></td>

//       <td>
//         <input
//           type="text"
//           value={editFormData.company || ""}
//           name="company"
//           onChange={handleEditFormChange}
//         />
//       </td>

//       <td></td>

//       <td>
//         <select
//           className="f4 bg-white tracked pa2"
//           value={editFormData.category || ""}
//           name="category"
//           onChange={handleEditFormChange}
//         >
//           {optionsPreviledges.map((option) => (
//             <option key={option.value} value={option.value}>
//               {option.text}
//             </option>
//           ))}
//         </select>
//       </td>

//       <td>
//         <select
//           className="f4 bg-white tracked pa2"
//           value={editFormData.status || ""}
//           name="status"
//           onChange={handleEditFormChange}
//         >
//           {statusOptions.map((option) => (
//             <option key={option.value} value={option.value}>
//               {option.text}
//             </option>
//           ))}
//         </select>
//       </td>

//       <td>
//         <div className="db">
//           {isLoadingSave ? (
//             <div className="dib ml2 mr2">
//               <Circles type="Oval" color="#000080" height={20} width={40} />
//             </div>
//           ) : null}
//           <div>
//             <button
//               className="br-pill bw0 bg-orange hover-bg-yellow white pa2"
//               onClick={handleEditFormSubmit}
//               disabled={isLoadingSave}
//             >
//               {isLoadingSave ? "Saving..." : "Save"}
//             </button>
//             <button
//               type="button"
//               className="ml2 br-pill bw0 bg-orange hover-bg-yellow white pa2"
//               onClick={handleCancelClick}
//             >
//               Cancel
//             </button>
//           </div>
//           <div>
//             <p>{foundErrAdd ? foundErrAdd : ""}</p>
//           </div>
//         </div>
//       </td>
//     </tr>
//   );
// };

// export default EditableRow;



// EditableRow.js (Users table)
// Styled to match the Records page's EditableRow.js: inline-styled inputs
// with a min-width so the row doesn't collapse, a highlighted background,
// and Save/Cancel pill buttons with a loading spinner. Unlike the old
// version, every field here is bound to editFormData directly (no separate
// "names" state that could drift out of sync with what's actually submitted).

import React from "react";
import { Circles } from "react-loader-spinner";

const EditableRow = ({
  editFormData,
  handleEditFormChange,
  handleEditFormSubmit,
  handleCancelClick,
  isLoadingSave,
  companiesList = [],
}) => {
  return (
    <tr className="bg-washed-yellow bb b--gold">
      {/* Select column (disabled while editing) */}
      <td className="pa2 tc nowrap">
        <input type="checkbox" disabled />
      </td>

      {/* ID */}
      <td className="pa2 fw5 dark-gray nowrap">{editFormData?.id}</td>

      {/* Farmer ID — autogenerated, not editable */}
      <td className="pa2 nowrap dark-gray">{editFormData?.farmerid || "-"}</td>

      {/* Username */}
      <td className="pa2 nowrap">
        <input
          type="text"
          name="username"
          value={editFormData?.username || ""}
          onChange={handleEditFormChange}
          placeholder="Username"
          className="pa2 ba b--light-gray br2 bg-white"
          style={{ minWidth: "140px" }}
          required
        />
      </td>

      {/* Email */}
      <td className="pa2 nowrap">
        <input
          type="email"
          name="email"
          value={editFormData?.email || ""}
          onChange={handleEditFormChange}
          placeholder="Email"
          className="pa2 ba b--light-gray br2 bg-white"
          style={{ minWidth: "200px" }}
          required
        />
      </td>

      {/* Phone */}
      <td className="pa2 nowrap">
        <input
          type="tel"
          name="phone"
          value={editFormData?.phone || ""}
          onChange={handleEditFormChange}
          placeholder="Phone"
          className="pa2 ba b--light-gray br2 bg-white"
          style={{ minWidth: "130px" }}
        />
      </td>

      {/* Company */}
      <td className="pa2 nowrap">
        <select
          name="company"
          value={editFormData?.company || ""}
          onChange={handleEditFormChange}
          className="pa2 ba b--light-gray br2 bg-white"
          style={{ minWidth: "160px" }}
        >
          <option value="">-- select company --</option>
          {(Array.isArray(companiesList) ? companiesList : []).map(
            (company, idx) => (
              <option key={idx} value={company.name}>
                {company.name}
              </option>
            )
          )}
        </select>
      </td>

      {/* Category */}
      <td className="pa2 tc nowrap">
        <select
          name="category"
          value={editFormData?.category || ""}
          onChange={handleEditFormChange}
          className="pa2 ba b--light-gray br2 bg-white fw6"
        >
          <option value="">-- select --</option>
          <option value="Farmer">Farmer</option>
          <option value="Clerk">Clerk</option>
        </select>
      </td>

      {/* Status */}
      <td className="pa2 tc nowrap">
        <select
          name="status"
          value={editFormData?.status || ""}
          onChange={handleEditFormChange}
          className="pa2 ba b--light-gray br2 bg-white fw6"
        >
          <option value="">-- select --</option>
          <option value="active">Active</option>
          <option value="pending">Pending</option>
          <option value="disabled">Disabled</option>
        </select>
      </td>

      {/* Joined */}
      <td className="pa2 tc nowrap">
        <span className="dark-gray">{editFormData?.joined || "-"}</span>
      </td>

      {/* Last Active */}
      <td className="pa2 tc nowrap">
        <span className="dark-gray">{editFormData?.lastactive || "-"}</span>
      </td>

      {/* Actions */}
      <td className="pa2 tc nowrap">
        {isLoadingSave && (
          <span className="dib mr3 v-mid">
            <Circles height={24} width={24} color="#ffb700" />
          </span>
        )}

        <button
          type="button"
          onClick={handleEditFormSubmit}
          disabled={isLoadingSave}
          className="bn br-pill bg-dark-green white pointer fw6 ph3 pv2 mr2 hover-bg-green"
        >
          Save
        </button>

        <button
          type="button"
          onClick={handleCancelClick}
          disabled={isLoadingSave}
          className="bn br-pill bg-light-red dark-red pointer fw6 ph3 pv2 hover-bg-red hover-white"
        >
          Cancel
        </button>
      </td>
    </tr>
  );
};

export default EditableRow;